<template>
<!--  
<div>
  <nav class="navbar bg-faded bg-dark">
    <div class="container">
      <ul class="nav navbar-nav navbar-logo mx-auto">
        <li class="nav-item">
          <img src="../assets/firma.png">
        </li>
      </ul>
     
    </div>
  </nav>
</div>
-->
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}

</script>

<style scoped="">
.bg-dark {
  height: 101px;
  background-color: #0A0305 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/YilmerNav.vue